import { module } from 'angular';

export const ANALYTICS_MODULE = 'spinnaker.core.analytics';
module(ANALYTICS_MODULE, [
  require('./analytics.service').name,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/analytics/analytics.module.ts